//Reset data
export const RESET = "POINT_FOCAL_UPDATE_RESET"

export const SET_IS_UPDATED = "POINT_FOCAL_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "POINT_FOCAL_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "POINT_FOCAL_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "POINT_FOCAL_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "POINT_FOCAL_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "POINT_FOCAL_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "POINT_FOCAL_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "POINT_FOCAL_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "POINT_FOCAL_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "POINT_FOCAL_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "POINT_FOCAL_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "POINT_FOCAL_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "POINT_FOCAL_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "POINT_FOCAL_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "POINT_FOCAL_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "POINT_FOCAL_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "POINT_FOCAL_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "POINT_FOCAL_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "POINT_FOCAL_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "POINT_FOCAL_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "POINT_FOCAL_UPDATE_SET_MODAL_TYPE"